import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
	<g>
		<g>
			<rect x="1.19" y="15.1" width="15.63" height="1.74"/>
			<g>
				<path d="M16.81,16.63c-5.21,0-10.42,0-15.63,0c0.06,0.06,0.13,0.13,0.19,0.19c0-0.58,0-1.16,0-1.74
					c-0.06,0.06-0.13,0.13-0.19,0.19c5.21,0,10.42,0,15.63,0c-0.06-0.06-0.13-0.13-0.19-0.19c0,0.58,0,1.16,0,1.74
					c0,0.24,0.37,0.24,0.37,0c0-0.58,0-1.16,0-1.74c0-0.09-0.09-0.19-0.19-0.19c-5.21,0-10.42,0-15.63,0C1.09,14.89,1,14.98,1,15.08
					c0,0.58,0,1.16,0,1.74C1,16.91,1.09,17,1.19,17c5.21,0,10.42,0,15.63,0C17.06,17,17.06,16.63,16.81,16.63z"/>
			</g>
		</g>
	</g>
	<g>
		<polygon points="4.68,7.63 6.92,8.13 6.99,1.19 11.03,1.19 11.1,8.13 13.36,7.63 9.01,13.36 		"/>
		<g>
			<path d="M4.62,7.8c0.75,0.17,1.51,0.35,2.26,0.52c0.11,0.02,0.24-0.06,0.24-0.19c0-2.3,0.02-4.63,0.06-6.95
				C7.12,1.24,7.05,1.32,6.99,1.37c1.34,0,2.71,0,4.05,0c-0.06-0.06-0.13-0.13-0.19-0.19c0.02,2.32,0.04,4.65,0.06,6.95
				c0,0.13,0.11,0.21,0.24,0.19c0.75-0.17,1.51-0.35,2.26-0.52c-0.07-0.09-0.15-0.19-0.21-0.28c-1.46,1.9-2.89,3.83-4.35,5.73
				c0.11,0,0.22,0,0.32,0c-1.46-1.9-2.89-3.83-4.35-5.73c-0.15-0.19-0.47,0-0.32,0.19c1.44,1.9,2.89,3.83,4.33,5.73
				c0.09,0.11,0.22,0.11,0.32,0c1.46-1.9,2.89-3.83,4.35-5.73c0.11-0.13-0.07-0.3-0.21-0.28c-0.75,0.17-1.51,0.35-2.26,0.52
				c0.07,0.06,0.15,0.11,0.24,0.19c-0.02-2.3-0.04-4.63-0.07-6.95c0-0.09-0.09-0.19-0.19-0.19C9.68,1,8.32,1,6.97,1
				C6.88,1,6.79,1.09,6.79,1.19C6.77,3.5,6.75,5.84,6.73,8.13c0.07-0.06,0.15-0.11,0.24-0.19C6.23,7.78,5.46,7.59,4.72,7.42
				C4.49,7.39,4.38,7.74,4.62,7.8z"/>
		</g>
	</g>
</g>, '0 0 18 18', 'DownloadIcon',
);
